import { SearchOrDiscoverPageBelowFooter } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/BelowFooter";
import { WithSearchPageData } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/DataProvider";
import { WithSearchPageErrorBoundary } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ErrorBoundary";
import { WithFilterRefContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/FilterRefContext";
import { FiltersAndResultsSubLayout } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/FiltersAndResultsSubLayout";
import { SearchPageLayout } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/Layout";
import { MaybeSearchPageFilterSideBar } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/MaybeSearchPageFilterSideBar";
import { SearchPageEffects } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageEffects/SearchPageEffects";
import { SearchPageFilterContextProvider } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageFilterContextProvider/SearchPageFilterContextProvider";
import { SearchPageFooter } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageFooter/SearchPageFooter";
import { SearchPageHeaderAndResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/SearchPageHeaderAndResults";
import React from "react";

export const SearchPage: React.FC = () => {
  return (
    <WithSearchPageData>
      <SearchPageFilterContextProvider>
        <SearchPageEffects />
        <WithSearchPageErrorBoundary>
          <WithFilterRefContext>
            <SearchPageLayout
              filterAndResults={
                <FiltersAndResultsSubLayout
                  filters={<MaybeSearchPageFilterSideBar />}
                  results={<SearchPageHeaderAndResults />}
                />
              }
              footer={<SearchPageFooter />}
            />
            <SearchOrDiscoverPageBelowFooter />
          </WithFilterRefContext>
        </WithSearchPageErrorBoundary>
      </SearchPageFilterContextProvider>
    </WithSearchPageData>
  );
};
